(function() {
  'use strict';

  function init(container) {
    if (!container || container.dataset.fastGalleryInit) return;
    container.dataset.fastGalleryInit = 'true';

    var track = container.querySelector('.fast-media-track');
    var slides = container.querySelectorAll('.fast-slide');
    var thumbs = container.querySelectorAll('.fast-media-thumb');
    var badgeCurrent = container.querySelector('.fast-media-current');

    if (!track || !slides.length) return;

    var prevBtn = container.querySelector('.fast-media-prev');
    var nextBtn = container.querySelector('.fast-media-next');

    var currentIndex = 0;
    var totalSlides = slides.length;
    var autoplayTimer = null;
    var resumeTimeout = null;
    var isVisible = false;
    var AUTOPLAY_DELAY = 2500;     // 4 seconds between autoplay slides
    var RESUME_DELAY = 3000;       // 3 seconds pause after user interaction
    var isRTL = document.documentElement.getAttribute('dir') === 'rtl' || document.body.classList.contains('rtl');

    // Efficient UI sync: Updates thumbnails and counter badge
    function updateThumbsAndBadge(idx) {
      thumbs.forEach(function(btn, i) {
        if (i === idx) {
          btn.classList.add('is-active');
          // Use behavior: 'auto' to prevent animation collision with track scroll
          btn.scrollIntoView({ behavior: 'auto', block: 'nearest', inline: 'nearest' });
        } else {
          btn.classList.remove('is-active');
        }
      });

      if (badgeCurrent) {
        badgeCurrent.textContent = idx + 1;
      }
    }

    // Smoothly scroll track to a specific slide index
    function scrollToSlide(idx, isUserAction) {
      if (idx < 0) idx = totalSlides - 1;
      if (idx >= totalSlides) idx = 0;

      if (isUserAction) {
        onUserInteraction();
      }

      currentIndex = idx;
      var target = slides[idx];
      if (!target) return;

      var targetLeft = target.offsetLeft - track.offsetLeft;
      track.scrollTo({
        left: targetLeft,
        behavior: 'smooth'
      });

      updateThumbsAndBadge(idx);
    }

    // Start autoplay timer
    function startAutoplay() {
      if (autoplayTimer || !isVisible || totalSlides <= 1) return;
      autoplayTimer = setInterval(function() {
        if (!isVisible) {
          pauseAutoplay();
          return;
        }
        var nextIdx = (currentIndex + 1) % totalSlides;
        scrollToSlide(nextIdx, false);
      }, AUTOPLAY_DELAY);
    }

    // Pause autoplay immediately
    function pauseAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    // When customer interacts: pause immediately, then schedule resume
    function onUserInteraction() {
      pauseAutoplay();

      if (resumeTimeout) {
        clearTimeout(resumeTimeout);
        resumeTimeout = null;
      }

      resumeTimeout = setTimeout(function() {
        resumeTimeout = null;
        if (isVisible) {
          startAutoplay();
        }
      }, RESUME_DELAY);
    }

    // Navigation button clicks
    if (prevBtn) {
      prevBtn.addEventListener('click', function(e) {
        e.preventDefault();
        var delta = isRTL ? 1 : -1;
        scrollToSlide(currentIndex + delta, true);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function(e) {
        e.preventDefault();
        var delta = isRTL ? -1 : 1;
        scrollToSlide(currentIndex + delta, true);
      });
    }

    // Thumbnails interaction
    thumbs.forEach(function(btn, i) {
      btn.addEventListener('click', function() {
        scrollToSlide(i, true);
      });
      btn.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          scrollToSlide(i, true);
        }
      });
    });

    // Zero-overhead gesture triggers (removed touchmove to eliminate 60-120 timer allocations/sec)
    track.addEventListener('touchstart', onUserInteraction, { passive: true });
    track.addEventListener('pointerdown', onUserInteraction, { passive: true });
    track.addEventListener('wheel', onUserInteraction, { passive: true });

    // O(1) Mathematical Scroll Tracking: zero DOM queries inside animation frame
    var scrollTicking = false;
    function onTrackScroll() {
      if (scrollTicking) return;
      scrollTicking = true;

      requestAnimationFrame(function() {
        var trackWidth = track.clientWidth;
        if (trackWidth > 0) {
          var scrollPos = Math.abs(track.scrollLeft);
          var activeIdx = Math.round(scrollPos / trackWidth);
          activeIdx = Math.max(0, Math.min(activeIdx, totalSlides - 1));

          if (activeIdx !== currentIndex) {
            currentIndex = activeIdx;
            updateThumbsAndBadge(activeIdx);
          }
        }
        scrollTicking = false;
      });
    }
    track.addEventListener('scroll', onTrackScroll, { passive: true });

    // IntersectionObserver: Only run autoplay while gallery is visible on screen
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.2) {
            isVisible = true;
            if (!resumeTimeout) {
              startAutoplay();
            }
          } else {
            isVisible = false;
            pauseAutoplay();
          }
        });
      }, {
        threshold: [0, 0.2]
      });
      observer.observe(container);
    } else {
      isVisible = true;
      startAutoplay();
    }

    // Pause autoplay on inactive browser tabs to save battery & processing power
    document.addEventListener('visibilitychange', function() {
      if (document.hidden) {
        pauseAutoplay();
      } else if (isVisible && !resumeTimeout) {
        startAutoplay();
      }
    });

    // Pause on desktop mouse hover, resume on mouse leave
    container.addEventListener('mouseenter', function() {
      pauseAutoplay();
    });
    container.addEventListener('mouseleave', function() {
      if (isVisible && !resumeTimeout) {
        startAutoplay();
      }
    });

    // Listen to theme variant changes (e.g. Minimog or standard theme events)
    if (window.MinimogEvents) {
      var prodId = container.getAttribute('data-product-id');
      if (prodId) {
        window.MinimogEvents.subscribe(prodId + '__VARIANT_CHANGE', function(variant) {
          if (variant && variant.featured_media) {
            var mediaId = variant.featured_media.id;
            var matchedIdx = -1;
            slides.forEach(function(s, i) {
              if (s.getAttribute('data-media-id') == mediaId) {
                matchedIdx = i;
              }
            });
            if (matchedIdx === -1 && variant.featured_media.position) {
              matchedIdx = (variant.featured_media.position - 1) || 0;
            }
            if (matchedIdx >= 0 && matchedIdx < totalSlides) {
              scrollToSlide(matchedIdx, true);
            }
          }
        });
      }
    }
  }

  window.initFastGallery = init;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      document.querySelectorAll('.fast-media-gallery').forEach(init);
    });
  } else {
    document.querySelectorAll('.fast-media-gallery').forEach(init);
  }
})();